import { useEffect } from "react";

const useTextAnimation = (activeIndex) => {
  useEffect(() => {
    const texts = document.querySelectorAll(".animated_text");

    const textAnimationIo = new IntersectionObserver(
      (targets) =>
        targets.forEach(({ target, isIntersecting }) => {
          target.classList[isIntersecting ? "add" : "remove"]("animate");
        }),
      { threshold: 0, root: document.body, rootMargin: "0px 0px -0px 0px" }
    );

    texts.forEach((text) => {
      textAnimationIo.observe(text);
    });

    return () => {
      textAnimationIo.disconnect();
    };
  }, [activeIndex]);
};

export default useTextAnimation;
